// extracted by mini-css-extract-plugin
export default {"Root":"header_Root__xTm5q","Logo":"header_Logo__TpIkq","Image":"header_Image__gJ0UZ","SiteTitle":"header_SiteTitle__SRll8","ThemeControls":"header_ThemeControls__Kw2Bo"};